import { ListItemButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ChatTopicWrapper = styled(ListItemButton)(({ theme }) => ({
  backgroundColor: theme.palette.greys.light,
  borderRadius: '24px',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: 'transparent',
  padding: theme.spacing(0.875, 1.875),
}));
